import React from "react";
import DashboardAdmin from "./dashboard-admin";

interface CustomerDashboardProps {
  role?: "superadmin" | "msp";
  mspId?: number;
}

export default function CustomerDashboard({
  role,
  mspId,
}: Readonly<CustomerDashboardProps>) {
  return <DashboardAdmin role={role || "msp"} mspId={mspId} />;
}
